import React from "react";

import { useFormikContext } from "formik";

import { Box, Divider, Flex, Grid, GridItem, Text } from "@chakra-ui/react";

import { Group } from "../../Group";
import { CustomInputWField } from "../../../../../components/CustomInputWField";
import CustomDropzone from "../../../../../components/CustomDropzone";
import { RadioOptions } from "../../RadioOptions";
import FileInformation from "../../../../../components/FileInformation";
import { certidaoNascimento } from "../../../../../utils/masks";

export const CriancaRegistrada = ({
  anexoEditado,
  setAnexoEditado,
  isNascidoAposMar2011,
  idAnexo,
  scrollToField,
}) => {
  const { setFieldValue, values, errors, touched } = useFormikContext();

  return (
    <Group
      border={idAnexo === "2" ? "3px solid #4299E199" : ""}
      scrollToField={idAnexo === "2" ? scrollToField : null}
    >
      <Text
        mt="5"
        mb="2"
        fontWeight={700}
        fontSize="16px"
        lineHeight="21.6px"
        color="#169499"
      >
        REGISTRO DE NASCIMENTO
      </Text>
      <Divider />
      <RadioOptions
        label="Criança é Registrada?*"
        fieldName="registrada"
        mt="20px"
        linkCertidao="http://www4.tjrj.jus.br/Portal-Extrajudicial/CNO/"
        errors={errors}
        touched={touched}
      />
      {values.registrada === "S" && (
        <Grid
          mt="15px"
          templateColumns={
            isNascidoAposMar2011 ? "repeat(5, 1fr)" : "repeat(2, 1fr) "
          }
          gap="25px"
          rowGap="20px"
        >
          <GridItem
            colSpan={{
              sm: 6,
              lg: isNascidoAposMar2011 ? 2 : 1,
            }}
          >
            <CustomInputWField
              maxLength={40}
              fieldName="matricula"
              label="Matrícula*"
              placeholder="Informe a Matrícula"
              onChange={(e) => {
                setFieldValue(
                  "matricula",

                  isNascidoAposMar2011
                    ? certidaoNascimento(e.target.value)
                    : e.target.value
                );
              }}
            />
          </GridItem>
          {isNascidoAposMar2011 && <GridItem />}
          {!isNascidoAposMar2011 && (
            <>
              <GridItem
                colSpan={{ base: 2, sm: 3, lg: isNascidoAposMar2011 ? 3 : 1 }}
              >
                <CustomInputWField
                  fieldName="livro"
                  label="Livro*"
                  placeholder="Informe o Livro"
                />
              </GridItem>
              <GridItem
                colSpan={{ base: 2, sm: 3, lg: isNascidoAposMar2011 ? 3 : 1 }}
              >
                <CustomInputWField
                  fieldName="folha"
                  label="Folha*"
                  placeholder="Informe a Folha"
                />
              </GridItem>
              <GridItem
                colSpan={{ base: 2, sm: 3, lg: isNascidoAposMar2011 ? 3 : 1 }}
              >
                <CustomInputWField
                  fieldName="termo"
                  label="Termo*"
                  placeholder="Informe o Termo"
                />
              </GridItem>
            </>
          )}
        </Grid>
      )}
      <Grid
        display={"flex"}
        flexDirection={{ base: "column", lg: "row" }}
        mt="25px"
        templateColumns="repeat(4, 1fr) 1fr"
        gap="25px"
      >
        {values.registrada === "S" && (
          <>
            <GridItem colSpan={{ base: 2, sm: 2, lg: 1 }}>
              {anexoEditado || !values.originalCertidao ? (
                <Flex>
                  <CustomDropzone
                    whiteSpace={true}
                    formProps={{ setFieldValue }}
                    title="Anexar Certidão de Nascimento"
                    fieldName="certidao"
                    setAnexoNaoEditado={
                      values.originalCertidao
                        ? () => {
                            setAnexoEditado(false);
                          }
                        : null
                    }
                    height="42px"
                    width={"216px"}
                  />
                </Flex>
              ) : (
                values.originalCertidao && (
                  <FileInformation
                    label="Anexar Certidão de Nascimento"
                    name={values.originalCertidao.nomeArquivo}
                    path={values.originalCertidao.path
                      .toString()
                      .split("/")
                      .pop()}
                    setAnexoEditado={() => {
                      setAnexoEditado(true);
                    }}
                    isVisualizacao={false}
                    height="42px"
                    width={"216px"}
                  />
                )
              )}
            </GridItem>
          </>
        )}
        <GridItem colSpan={{ base: 2, sm: 2, lg: 1 }}>
          <Box width={{ lg: "450.48px" }}>
            <CustomInputWField
              whiteSpace={true}
              fieldName="numeroSolicitacaoCertNascimento"
              label="Número de solicitação do documento ao órgão responsável"
              placeholder="Informe o Número de Solicitação"
            />
          </Box>
        </GridItem>
      </Grid>
    </Group>
  );
};
